var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { UnauthorizedError } from '@lucidlink/sdk/fetcher';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { LOGIN_WIZARD_STEPS, useDependency, useGetAuthCodeHandler, useGetUserLoginConfig, usePasswordLogin, useSSOClient, useSubscribeToBroadcastMessage, } from '@lucidlink/workspacemanagement';
export const useLoginPassword = ({ handleGeneralLoginError, loginEmail, setAccessToken, setNextStep, }) => {
    _react_refresh_temp_1();
    const { formData, methods: { injectErrors }, } = useFormRoot();
    const { data: userLoginConfig } = useGetUserLoginConfig(loginEmail);
    const onLoginError = useCallback((e) => {
        if (e instanceof UnauthorizedError) {
            injectErrors({
                password: {
                    override: true,
                    errors: [
                        {
                            code: 'user.wrongCredentials',
                            path: [],
                            message: '',
                            isServerError: true,
                        },
                    ],
                },
            });
        }
        else {
            handleGeneralLoginError();
        }
    }, [handleGeneralLoginError, injectErrors]);
    const { mutation: { isPending: isPendingLogin, mutate: login }, } = usePasswordLogin({ onError: onLoginError });
    const loginWithPassword = useCallback(() => {
        if (!formData.password) {
            return;
        }
        login({ email: loginEmail, password: formData.password });
    }, [formData.password, login, loginEmail]);
    const { exchangeCode, initializeAuthentication } = useSSOClient();
    const onAuthCodeReceived = useGetAuthCodeHandler({
        exchangeCode,
        handleGeneralLoginError,
        loginEmail,
        setAccessToken,
        setNextStep,
    });
    useSubscribeToBroadcastMessage({
        callback: onAuthCodeReceived,
        messageType: 'auth-code-received',
    });
    const clientBaseUrl = useDependency('CLIENT_BASE_URL');
    const loginWithSso = useCallback(async () => {
        // If > 1 workspace has SSO enabled, we need to get the
        // workspace name to get ssoLoginParams, they'll be `null` here
        if (userLoginConfig?.isWorkspaceNameRequired) {
            setNextStep(LOGIN_WIZARD_STEPS.WORKSPACE_NAME);
            return;
        }
        // if `isWorkspaceNameRequired` is false, we must have SSO params
        // to proceed immediately with SSO login
        // TODO: Actually reset the form or what? Here nothing will happen
        // which is a bit weird UX-wise
        if (!userLoginConfig?.ssoLoginParams) {
            return;
        }
        const { ssoLoginParams } = userLoginConfig;
        await initializeAuthentication({
            clientId: ssoLoginParams.clientId,
            serverUri: ssoLoginParams.openIdConnectUrl,
            redirectUri: `${clientBaseUrl}/sso-landing`,
            loginHint: loginEmail,
        });
    }, [
        clientBaseUrl,
        initializeAuthentication,
        loginEmail,
        setNextStep,
        userLoginConfig,
    ]);
    return { loginWithSso, loginWithPassword, isPendingLogin, userLoginConfig };
};
_react_refresh_temp_1(useLoginPassword, "n5x7qjsXPMBk4nIR8CK0i1Y41Xk=", false, () => [useFormRoot, useGetUserLoginConfig, usePasswordLogin, useSSOClient, useGetAuthCodeHandler, useSubscribeToBroadcastMessage, useDependency]);
